import apiClient from "@/app/api/client";
import type {
	AttendanceDayDetail,
	AttendanceEvent,
	CorrectionInput,
	EmployeeRoutePoint,
} from "../types";

interface SingleResponse<T> {
	success: true;
	data: T;
}

export const attendanceService = {
	async getDay(id: string): Promise<AttendanceDayDetail> {
		const response = await apiClient.get<SingleResponse<AttendanceDayDetail>>(
			`/attendance/days/${id}`
		);

		return response.data.data;
	},

	async createCorrection(dayId: string, input: CorrectionInput): Promise<AttendanceEvent> {
		const response = await apiClient.post<SingleResponse<AttendanceEvent>>(
			`/attendance/days/${dayId}/corrections`,
			input
		);

		return response.data.data;
	},

	/** Xodimning harakat yo'li (P8 §8.1) — `date` berilmasa sozlangan zonadagi joriy ish kuni. */
	async getEmployeeRoute(employeeId: string, date?: string): Promise<EmployeeRoutePoint[]> {
		const response = await apiClient.get<SingleResponse<{ points: EmployeeRoutePoint[] }>>(
			`/attendance/live-map/${employeeId}/route`,
			{ params: date ? { date } : undefined }
		);

		return response.data.data.points;
	},
};
